import React from 'react';
import constants from '../../../constants/constants';
import './ChatEmptyState.css';

const ChatEmptyState = ({ onPickSuggestion, disabled }) => (
    <div className='chat-empty'>
        <div className='chat-empty__icon' aria-hidden='true'>
            🎾
        </div>
        <h2 className='chat-empty__title'>{constants.CHAT.EMPTY_TITLE}</h2>
        <p className='chat-empty__subtitle'>{constants.CHAT.EMPTY_SUBTITLE}</p>

        <div className='chat-empty__suggestions'>
            {constants.CHAT.SUGGESTIONS.map((suggestion) => (
                <button
                    key={suggestion}
                    type='button'
                    className='chat-empty__suggestion'
                    onClick={() => onPickSuggestion(suggestion)}
                    disabled={disabled}
                >
                    {suggestion}
                </button>
            ))}
        </div>
    </div>
);

export default ChatEmptyState;
